// iconos en https://material.io/tools/icons/?style=baseline
// con buscador en https://material-ui.com/es/components/material-icons/
// eslint-disable-next-line
import * as i from "@material-ui/icons";
import {
  ROLE_GESTION_USUARIOS,
  ROLE_MAS_BRAN,
  ROUTES_DEVICES,
  ROUTES_HOME,
  ROUTES_SESSIONS,
  ROUTES_USER_MANAGEMENT,
  ROUTES_USERS,
} from "../utils/constants";
// eslint-disable-next-line

export const menuDefsAdmin = [
  {
    name: "menu.home",
    icon: i.HomeRounded,
    perms: ROLE_MAS_BRAN,
    url: ROUTES_HOME,
  },
  {
    name: "menu.user_management",
    icon: i.People,
    perms: ROLE_GESTION_USUARIOS,
    itemDefs: [
      {
        name: "menu.about",
        icon: i.InfoOutlined,
        url: ROUTES_USER_MANAGEMENT,
      },
      {
        name: "menu.user_list",
        icon: i.Group,
        url: ROUTES_USERS,
      },
      {
        name: "menu.device_list",
        icon: i.DevicesRounded,
        url: ROUTES_DEVICES,
      },
      {
        name: "menu.session_list",
        icon: i.DynamicFeedRounded,
        url: ROUTES_SESSIONS,
      },
    ],
  },
  /*{
      name: "custom.migration.status",
      icon: i.SwapHorizRounded,
      //perms: (p) => hasFeature(p, "RPV"),
      url: "/migration"
    },*/
  /*{
      name: "menu.panel_3",
      icon: i.VideoLabelRounded,
      //perms: (p) => hasFeature(p, "RPV"),
      url: "/panel-3"
    }*/
];
